/*
 *
 * HandlersPanel reducer
 *
 */

import ActionTypes from './constants';
import ModeBarActionTypes from '../ModeBar/constants';
import { ContainerActions, ContainerState } from './types';

export const initialState: ContainerState = {
  isVisible: false,
  positionsSelected: [],
  color: undefined,
  type: undefined,
  material: undefined,
};

function handlesPanelReducer(
  state: ContainerState = initialState,
  action: any,
): ContainerState {
  switch (action.type) {
    case ActionTypes.DISPLAY_HANDLES_PANEL:
      return {
        ...state,
        isVisible: action.payload.value,
        positionsSelected: [],
      };
    case ActionTypes.SELECTION_HANDLES:
      return { ...state, positionsSelected: action.payload.positions };
    case ActionTypes.SELECT_PAINT_DOOR_HANDLE:
      return {
        ...state,
        color: action.payload.color,
        type: action.payload.type,
        material: action.payload.material,
      };
    case ActionTypes.SELECT_PAINT_DRAWER_HANDLE:
      return {
        ...state,
        color: action.payload.color,
        type: action.payload.type,
      };
    case ModeBarActionTypes.SWITCH_HANDLE_MODE:
      return {
        ...state,
        color: undefined,
        type: undefined,
      };
    default:
      return state;
  }
}

export default handlesPanelReducer;
